const typographyModalEquipServQuest = {
  true: 'New',
  false: 'Edit',
  text: 'Question',
  profileError: 'Wait for the file to upload'
};

export default typographyModalEquipServQuest;
